import React from 'react';
import { Link } from 'react-router-dom';
import heroImage from '../assets/images/heroImage.jpg'
import '../styles/Home.css'

function Home() {
  return (
    <div>
      <div className='home' style={{ backgroundImage: `url(${heroImage})` }}>
        <div className='headerContainer' >
          <p>An Autograph collection celebrating Nebraska related signatures in honor of my father, Bill Bellinger</p>
          <Link to="/collection">
            <button>View Collection</button>
          </Link>  
        </div>
      </div>  
    </div>
  )
}

export default Home
